// API Configuration
// On React Native, never use localhost (device = self). Use Render HTTPS so iOS ATS allows it.
import { Platform } from 'react-native';
const isWeb = Platform.OS === 'web';

const DEFAULT_PAYMENT_API = 'https://bookapt-payment-api.onrender.com';

function resolveApiBaseUrl(): string {
  const fromEnv = String(
    (typeof process !== 'undefined' && process.env.REACT_APP_API_BASE_URL) ||
      (typeof process !== 'undefined' && process.env.REACT_APP_PAYMENT_API_URL) ||
      ''
  ).trim();
  if (fromEnv) {
    const root = fromEnv.replace(/\/+$/, '');
    return root.endsWith('/api') ? root : `${root}/api`;
  }
  if (
    isWeb &&
    typeof __DEV__ !== 'undefined' &&
    __DEV__ &&
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  ) {
    return 'http://localhost:3000/api';
  }
  return `${DEFAULT_PAYMENT_API}/api`;
}

// update here: change API base for different environments
export const API_BASE_URL = resolveApiBaseUrl();

// update here: add/remove endpoint paths when backend features change
export const API_ENDPOINTS = {
  LOGIN: '/auth/login',
  APPOINTMENTS: '/appointments',
  APPOINTMENTS_STATS: '/appointments/stats',
  WORKERS: '/appointments/workers',
  BUSINESS_INFO: '/appointments/business-info',
};

export const API_HEADERS = {
  'Content-Type': 'application/json',
};

export const getAuthHeaders = (token: string) => ({
  ...API_HEADERS,
  'Authorization': `Bearer ${token}`,
});
